.grid-mini-button-container{width:auto}
/*# sourceMappingURL=treaty-rate-cell.component-HK4ODJQ6.css.map */
